/** Transloco keys relative to the `ACTIVITY_BROWSER` scope. */
export const ACTIVITY_EDIT_PEDAGOGICAL_CUSTOM_I18N_PREFIX = 'DETAIL.EDIT_PAGE.CUSTOM_FIELDS';

/** ProblemDetails `title` when the custom-field set no longer matches the reorder request (KT-1081). */
export const CUSTOM_PEDAGOGICAL_FIELD_REORDER_STALE = 'CustomPedagogicalField.ReorderStale';
